/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const extractOrigin = (url: string) => {
    const [protocol, restOfUrl] = url.split('//');
    const slashIndex = restOfUrl.indexOf('/');
    const hostName = restOfUrl.slice(0, slashIndex === -1 ? undefined : slashIndex);

    return `${protocol}//${hostName}`;
};
